/**
 * VSplitContainer parser: delegates to the shared SplitContainer base (Control plus
 * `split_offset`, `collapsed`, `dragger_visibility`). This slice adds only the axis, a Component
 * concern.
 */
import { parseSplitContainer } from '../shared/splitContainer';
export function parseVSplitContainer(heading, properties) {
    return parseSplitContainer(heading, properties);
}
//# sourceMappingURL=parser.js.map